
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  computed: {
    customClasses: function () {
      const list = ['heading-block', this.cfgs.customClasses];
      if (this.values.icon) {
        list.push('flex-center');
      }

      return list.join(' ');
    },
  },
});
